import React, { FC } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { IoChevronForward } from "react-icons/io5";

interface ITableViewDetailsColumnProps {
  contactId: string;
  contactType: string;
  onOpenContactDrawer: (contactId: string, contactType: string) => void;
}

export const TableViewDetailsColumn: FC<ITableViewDetailsColumnProps> = ({
  contactId,
  contactType,
  onOpenContactDrawer,
}) => {
  const handleOpen = () => {
    onOpenContactDrawer(contactId, contactType);
  };

  return (
    <GridActionsCellItem
      onClick={handleOpen}
      size="medium"
      icon={<IoChevronForward size={24} />}
      label="Details"
    />
  );
};
